import React from "react";
import ReactDOM from "react-dom";
import dotenv from "dotenv";
dotenv.config();
import { initializeAnalytics, trackPageView } from "utils/analytics";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import "./index.css";
import "./styles/main.css";
import reportWebVitals from "reportWebVitals";

//disable loggings in production
if (process.env.REACT_APP_TEST === "RELEASE") console.log = () => {};

initializeAnalytics();
reportWebVitals(trackPageView);
ReactDOM.render(<App />, document.getElementById("root"));
registerServiceWorker();
